// removed by extract-text-webpack-plugin
module.exports = {"burger":"BurgerButton__burger-1WtA4","isBackMode":"BurgerButton__isBackMode-38-pJ","toggle":"BurgerButton__toggle-1IWJ2","icon":"BurgerButton__icon-2jV8C"};